export default __webpack_public_path__ + "static/media/ExportIcon.30b50df8.svg";